module.exports = __webpack_public_path__ + "images/interview-McDonalds-2.svg";